/**
 * The key used to store and retrieve the user's locale preference
 * from the ECM preferences API (`/api/v3/companies/{companyId}/ecm-preferences`).
 */
export const LOCALE_PREFERENCE_KEY = "locale";
